import axios from '@/libs/axios'
import { API_CONFIG } from '@/config/api'

class AuthService {
  /**
   * Iniciar sesión
   * @param {Object} credentials - Credenciales de login
   * @param {string} credentials.usuario - Nombre de usuario
   * @param {string} credentials.password - Contraseña
   * @returns {Promise<Object>} - Respuesta del servidor con token y datos del usuario
   */
  async login(credentials) {
    try {
      const response = await axios.post(API_CONFIG.ENDPOINTS.AUTH.LOGIN, credentials)
      
      if (response.data) {
        // Extraer el rol del array de roles
        const userRole = response.data.user.roles && response.data.user.roles.length > 0
          ? response.data.user.roles[0].nombre || response.data.user.roles[0]
          : 'usuario'
        
        // Preparar datos del usuario con abilities
        const userData = {
          ...response.data.user,
          role: typeof userRole === 'string' ? userRole.toLowerCase() : 'usuario',
          ability: this.getUserAbilities(userRole)
        }
        
        // Guardar token en localStorage
        localStorage.setItem('accessToken', response.data.token)
        localStorage.setItem('userData', JSON.stringify(userData))
        
        console.log('✅ Datos guardados en localStorage:', {
          token: response.data.token.substring(0, 20) + '...',
          userData: userData,
          abilities: userData.ability
        })
        
        return {
          ...response.data,
          user: userData
        }
      }
      
      throw new Error('No se recibieron datos del servidor')
    } catch (error) {
      console.error('Error en login:', error)
      throw error
    }
  }

  /**
   * Obtener perfil del usuario
   * @returns {Promise<Object>} - Datos del perfil del usuario
   */
  async getProfile() {
    try {
      const response = await axios.get(API_CONFIG.ENDPOINTS.AUTH.PROFILE)
      return response.data
    } catch (error) {
      console.error('Error al obtener perfil:', error)
      throw error
    }
  }

  /**
   * Cerrar sesión
   */
  logout() {
    localStorage.removeItem('accessToken')
    localStorage.removeItem('userData')
  }

  /**
   * Verificar si el usuario está autenticado
   * @returns {boolean}
   */
  isAuthenticated() {
    return !!localStorage.getItem('accessToken')
  }

  /**
   * Obtener token de acceso
   * @returns {string|null}
   */
  getToken() {
    return localStorage.getItem('accessToken')
  }

  /**
   * Obtener datos del usuario
   * @returns {Object|null}
   */
  getUserData() {
    const userData = localStorage.getItem('userData')
    return userData ? JSON.parse(userData) : null
  }

  /**
   * Obtener abilities del usuario basado en su rol
   * @param {string} role - Rol del usuario
   * @returns {Array} - Array de abilities
   */
  getUserAbilities(role) {
    const normalizedRole = role ? role.toLowerCase() : ''
    
    const baseAbilities = [
      {
        action: 'read',
        subject: 'Auth',
      }
    ]

    switch (normalizedRole) {
      case 'admin':
      case 'administrador':
        return [
          ...baseAbilities,
          {
            action: 'manage',
            subject: 'admin',
          },
          {
            action: 'manage',
            subject: 'coordinador',
          },
          {
            action: 'manage',
            subject: 'CoordinadorSubject',
          },
          {
            action: 'read',
            subject: 'reports',
          }
        ]
      case 'coordinador':
        return [
          ...baseAbilities,
          {
            action: 'manage',
            subject: 'coordinador',
          },
          {
            action: 'manage',
            subject: 'CoordinadorSubject',
          },
          {
            action: 'read',
            subject: 'reports',
          }
        ]
      case 'consulta':
      case 'usuario':
        return [
          ...baseAbilities,
          {
            action: 'read',
            subject: 'reports',
          }
        ]
      default:
        return baseAbilities
    }
  }
}

export default new AuthService()

